export function allowShippingQuoteOnStore(currentStore)
{
    return (['AU', 'AU_SCA', 'AU_NRMA', 'NZ', 'NZ_SCA'].indexOf(currentStore) >= 0);
}
